import { render, staticRenderFns } from "./activity-count-details.vue?vue&type=template&id=9b23c446&scoped=true&"
import script from "./activity-count-details.vue?vue&type=script&lang=js&"
export * from "./activity-count-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-count-details.vue?vue&type=style&index=0&id=9b23c446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b23c446",
  null
  
)

export default component.exports